import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkout", "flash"];
  static values = { publishableKey: String, paymentIntentSuccessUrl: String, createIntentUrl: String };

  loadStripe = null;
  loaded = false;

  csrfToken() {
    const meta = document.querySelector('meta[name=csrf-token]');
    const token = meta && meta.getAttribute('content');

    return token ?? false;
  }

  display_error(error) {
    const flashContainer = this.flashTarget;
    const messageContainer = this.flashTarget.querySelector(`.alert__message`)
    messageContainer.textContent = error.message;
    flashContainer.classList.remove("hidden");
    setTimeout(function () {
      flashContainer.classList.add("hidden");
      messageContainer.textContent = '';
    }, 5500);
  }

  async initLoadStripe() {
    if (!this.loaded) {
      if (!this.loadStripe) {
        await import("!@stripe/stripe-js").then(
            ((loadstripe) => {
              this.loadStripe = loadstripe.loadStripe(this.publishableKeyValue, {betas: ["blocked_card_brands_beta_2"]});
            }).bind(this)
        );
      }
    }
  }

  async connect() {
    await this.initLoadStripe()
    const return_url = this.paymentIntentSuccessUrlValue
    const create_intent_url = this.createIntentUrlValue
    const stripe = await this.loadStripe
    this.flashTarget.classList.add("hidden");

    // Create the CustomerSession and obtain its clientSecret
    const res = await fetch(create_intent_url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': this.csrfToken(),
      }
    });

    const {
      customer_session_client_secret: customerSessionClientSecret,
      client_secret: clientSecret,
      error: error
    } = await res.json();

    if (error) {
      this.display_error(error)
    } else {
      const elementsOptions = {
        clientSecret: clientSecret,
        customerSessionClientSecret,
        disallowedCardBrands: ['american_express'],
        // Fully customizable with appearance API.
        appearance: {/*...*/},
      };

// Set up Stripe.js and Elements to use in checkout form, passing the client secret
// and CustomerSession's client secret obtained in a previous step
      const elements = stripe.elements(elementsOptions);

// Create and mount the Payment Element
      const paymentElementOptions = {
        layout: {
          type: 'tabs',
          defaultCollapsed: false,
        }
      };
      const paymentElement = elements.create('payment', paymentElementOptions);
      paymentElement.mount('#payment-element');

      const form = document.getElementById('payment-form');

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const {error} = await stripe.confirmPayment({
          //`Elements` instance that was used to create the Payment Element
          elements: elements,
          confirmParams: {
            return_url: return_url,
          }
        });

        if (error) {
          // This point will only be reached if there is an immediate error when
          // confirming the payment. Show error to your customer (for example, payment
          // details incomplete)
          const flashContainer = this.flashTarget;
          const messageContainer = this.flashTarget.querySelector(`.alert__message`)
          messageContainer.textContent = error.message;
          flashContainer.classList.remove("hidden");
          setTimeout(function () {
            flashContainer.classList.add("hidden");
            messageContainer.textContent = '';
          }, 5500);
        } else {
          // Your customer will be redirected to your `return_url`. For some payment
          // methods like iDEAL, your customer will be redirected to an intermediate
          // site first to authorize the payment, then redirected to the `return_url`.
        }
      });
    }
  }
}
